import { useCallback, useState } from "react";
import matchService from "../../../../services/api/matchService";
import {
  buildEventPayload,
  getInitialEventData,
  getNextEventDataAfterSubmit,
} from "../utils/eventFormUtils";

const useLiveMatchEventForm = ({ scoringTemplate, handleSendEvent, setError }) => {
  const [showEventForm, setShowEventForm] = useState(false);
  const [eventData, setEventData] = useState(getInitialEventData());

  const handleAddEvent = useCallback(
    async (event) => {
      event.preventDefault();

      try {
        setError(null);

        const validationErrors = matchService.validateEventData(
          eventData,
          scoringTemplate?.scoring_type
        );

        if (validationErrors.length > 0) {
          setError(validationErrors.join(", "));
          return;
        }

        await handleSendEvent(eventData.event_type, buildEventPayload(eventData));

        setEventData(getNextEventDataAfterSubmit(eventData));
        setShowEventForm(false);
      } catch (err) {
        console.error("❌ Error adding event:", err);
        setError(err.message || "Failed to add scoring event");
      }
    },
    [eventData, handleSendEvent, scoringTemplate, setError]
  );

  const getEventTypes = useCallback(() => {
    if (!scoringTemplate) return [];
    return matchService.getEventTypesForSport(scoringTemplate.scoring_type);
  }, [scoringTemplate]);

  return {
    showEventForm,
    setShowEventForm,
    eventData,
    setEventData,
    handleAddEvent,
    getEventTypes,
  };
};

export default useLiveMatchEventForm;
